import { setEnvToWindow } from './setEnvToWindow';
export var fetchEnv = function fetchEnv(mode, authLoginType) {
  return new Promise(function (resolve, reject) {
    var fetchUrl = "/component-shared-center/env.json";
    fetch(fetchUrl).then(function (r) {
      return r.json();
    }).then(function (res) {
      setEnvToWindow(res);
      resolve(res);
    }).catch(function (e) {
      reject(e);
    });
  });
};